import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  NotaComercialApiResponse,
  CadastroNotaComercialApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  DocumentRequest,
  Document,
  CadastroInstrumentoFinanceiroApiRequest,
  CommandResult,
  CommandResultTyped,
  CadastroNCByFile,
  postNotaComercialByFileResponse,
  getNotaComercialByFileResponse,
  GETNotasComerciaisByFileParams,
  GETFileNotaComercialByFileParams,
  getFileByNotaComercialResponse,
  postFundosInvestidoresLoteByFileResponse,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { ArquivosMultiplos, BatchFileDownloadResponse } from 'common/types/arquivosMultiplos';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETNotaComercialDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<NotaComercialApiResponse> => {
  return await request(
    () => axiosInstance.get<NotaComercialApiResponse>(`${requestConfig.api}api/v1/notas-comerciais/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETNotasComerciais = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
): Promise<Array<NotaComercialApiResponse>> => {
  return await request(
    () =>
      axiosInstance.get<Array<NotaComercialApiResponse>>(
        `${requestConfig.api}api/v1/notas-comerciais`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETNotasComerciaisByEmissorCnpj = async (
  dispatch: Dispatch,
  cnpjEmissor?: string,
  stackRequest: boolean = false
): Promise<Array<{codigo: string}>> => {
  return await request(
    () =>
      axiosInstance.get<Array<NotaComercialApiResponse>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/codigos?emissorCnpj=${cnpjEmissor}`,
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETNotaComercialByInstrumentoId = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
): Promise<NotaComercialApiResponse> => {
  return await request(
    () =>
      axiosInstance.get<NotaComercialApiResponse>(
        `${requestConfig.api}api/v1/notas-comerciais/instrumento-financeiro/${id}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTNotaComercial = async (
  dispatch: Dispatch,
  notaComercial: CadastroNotaComercialApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.post<NotaComercialApiResponse>(`${requestConfig.api}api/v1/notas-comerciais`, notaComercial),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const POSTNotaComercialByFile = async (
  dispatch: Dispatch,
  notaComercial: CadastroNCByFile,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.post<postNotaComercialByFileResponse>(`${requestConfig.api}api/v1/arquivos/saveFile`, notaComercial),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const POSTDownloadMultipleFiles = async (
  dispatch: Dispatch,
  params: ArquivosMultiplos,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.post<BatchFileDownloadResponse[]>(`${requestConfig.api}api/v1/arquivos/downloadMultipleFiles`, params),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const POSTNotaComercialCadastroEmLoteByFile = async (
  dispatch: Dispatch,
  file?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  if (file) fileForm.append('anexo', file);
  return await request(
    () => axiosInstance.post<postNotaComercialByFileResponse>(`${requestConfig.api}api/v1/investidores/lote`, fileForm),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const POSTFundosInvestidoresLoteByFile = async (
  dispatch: Dispatch,
  file?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  if (file) fileForm.append('anexo', file);
  return await request(
    () => axiosInstance.post<postFundosInvestidoresLoteByFileResponse>(`${requestConfig.api}api/v1/investidores/fundos-lote`, fileForm),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const GETAllNotasComerciaisByFile = async (
  dispatch: Dispatch,
  params: GETNotasComerciaisByFileParams,
  stackRequest: boolean = false
) => {

  let url: string;
  if (params.diretorio === undefined) {
    url = `${requestConfig.api}api/v1/arquivos/getAll`;
  } else {
    url = `${requestConfig.api}api/v1/arquivos/getAll?Diretorio=${params.diretorio}`;
  }

  return await request(
    () => axiosInstance.get<Array<getNotaComercialByFileResponse>>(url),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETFileNotaComercialByFile = async (
  dispatch: Dispatch,
  params: GETFileNotaComercialByFileParams,
  stackRequest: boolean = false,  
) => {
  const url = `${requestConfig.api}api/v1/arquivos/downloadFile?Diretorio=${params.diretorio}&NomeArquivo=${params.nomeArquivo}`;
  
  return await request(
    () => axiosInstance.get<getFileByNotaComercialResponse>(url),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const GETFileDownloadArquivo = async (
  dispatch: Dispatch,
  params: GETFileNotaComercialByFileParams,
  stackRequest: boolean = false,  
): Promise<Blob> => {
  const url = `${requestConfig.api}api/v1/arquivos/download?Diretorio=${encodeURIComponent(params.diretorio)}&NomeArquivo=${encodeURIComponent(params.nomeArquivo)}&BucketName=${encodeURIComponent(params.bucket || '')}`;
  
  return await request(
    () => axiosInstance.get<Blob>(url, { responseType: 'blob' }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTNotaComercial = async (
  dispatch: Dispatch,
  notaComercialId: string,
  notaComercial: CadastroNotaComercialApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<NotaComercialApiResponse>(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}`,
        notaComercial
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTEditarNotaComercial = async (
  dispatch: Dispatch,
  notaComercialId: string,
  notaComercial: CadastroNotaComercialApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const notaComercialStringfyed = JSON.stringify(notaComercial);
  fileForm.append('notaComercialRequest', notaComercialStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/notas-comerciais/editar/${notaComercialId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTNotaComercialAditamento = async (
  dispatch: Dispatch,
  notaComercialId: string,
  notaComercial: CadastroNotaComercialApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(notaComercial));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/notas-comerciais/aditamento/${notaComercialId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  notaComercialId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}/document`,
        data,
        {
          params: {
            emissionType,
          },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  notaComercialId: string,
  notaComercialDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.delete(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}/document/${notaComercialDocumentId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTermoConstitutivo = async (
  dispatch: Dispatch,
  notaComercial: CadastroInstrumentoFinanceiroApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<Document>(`${requestConfig.api}api/v1/notas-comerciais/termos-constitutivos`, notaComercial),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpNotaComercial = async (
  dispatch: Dispatch,
  notaComercial: CadastroNotaComercialApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<NotaComercialApiResponse>(
        `${requestConfig.api}api/v1/notas-comerciais/transferencia-dvm`,
        notaComercial
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  notaComercialId: string,
  notaComercialSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<NotaComercialApiResponse>(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}/enviar-liquidacao`,
        notaComercialSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoNotaComercial = async (
  dispatch: Dispatch,
  notaComercialId: string,
  precoUnitarioLiquidacao: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<NotaComercialApiResponse>(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}/confirmar-liquidacao`,
        { precoUnitario: precoUnitarioLiquidacao },
        { headers: { 'Content-Type': 'application/json' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoNotaComercial = async (
  dispatch: Dispatch,
  notaComercialId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(
        `${requestConfig.api}api/v1/notas-comerciais/${notaComercialId}/historico-de-alteracoes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoNotaComercial = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/notas-comerciais/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoNotaComercial = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/notas-comerciais/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};